var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document_pending",
    transform: "translate(-86 -527)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(86 527)",
    fill: "#e5be0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M5.073,0A3.6,3.6,0,0,0,1.88,1.689a.446.446,0,0,0,.1.61l.8.607a.445.445,0,0,0,.617-.077,1.8,1.8,0,0,1,1.535-.917c.571,0,1.277.367,1.277.921,0,.418-.345.633-.909.949-.657.368-1.527.827-1.527,1.974v.182a.445.445,0,0,0,.445.445H5.559A.445.445,0,0,0,6,5.937V5.83C6,5.035,8.329,5,8.329,2.85A3.188,3.188,0,0,0,5.073,0ZM4.887,6.929A1.285,1.285,0,1,0,6.172,8.214,1.287,1.287,0,0,0,4.887,6.929Z",
    transform: "translate(88.436 529.75)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPending);
export default __webpack_public_path__ + "static/media/document_pending.70c7c0226b5166055c62a0277eadff92.svg";
export { ForwardRef as ReactComponent };